// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contactRoleEntity from './entities/contact-role.json';
import contactRoleMenu from '../pages/contact-role/menu.json';
import contactRoleFullForm from '../pages/contact-role/forms/full.json';
import contactRoleContextForm from '../pages/contact-role/forms/context.json';
import contactRoleMiniForm from '../pages/contact-role/forms/mini.json';
import contactRoleLookupForm from '../pages/contact-role/forms/lookup.json';
import contactRoleTableView from '../pages/contact-role/views/table.json';
import contactRoleCardsView from '../pages/contact-role/views/cards.json';
import contactRoleCalendarView from '../pages/contact-role/views/calendar.json';
import contactRoleDashboardView from '../pages/contact-role/views/dashboard.json';

/** Тип запису «Роль контакту» зі сторінками пакета: меню, форми та подання з pages/contact-role/. */
export const contactRoleDefinition: IRecordTypeDefinition = {
  ...contactRoleEntity,
  views: assembleViewSet({
      table: contactRoleTableView,
      cards: contactRoleCardsView,
      calendar: contactRoleCalendarView,
      dashboard: contactRoleDashboardView,
  }),
  form: contactRoleFullForm,
  forms: { full: contactRoleFullForm, context: contactRoleContextForm, mini: contactRoleMiniForm, lookup: contactRoleLookupForm },
  menu: contactRoleMenu,
} as IRecordTypeDefinition;
